$(function () {
    const disabledDates = [
        '2023-10-02',
        '2023-10-09',
        '2023-11-13',
        '2023-12-22',
        '2023-12-23',
        '2023-12-24',
        '2023-12-25',
        '2023-12-26',
        '2023-12-27',
        '2023-12-28',
        '2023-12-29',
        '2023-12-30',
        '2023-12-31',
        '2024-01-01',
        '2024-01-02',
        '2024-02-19',
        '2024-03-29',
        '2024-07-01',
        '2024-09-02',
        '2024-12-25',
        '2025-01-01',
        '2025-02-17',
        '2025-04-18',
        '2025-07-01',
        '2025-09-01',
        '2025-12-25',
        '2026-01-01',
        '2026-02-16',
        '2026-04-03',
        '2026-07-01',
        '2026-09-07',
        '2026-12-25',
        '2027-01-01',
        '2027-02-15',
        '2027-03-26',
        '2027-07-01',
        '2027-09-06',
        '2027-12-27',
    ];

    const minDate = function () {
        const hourInHalifax = new Date().toLocaleString(
            'en-US',
            { hour: '2-digit', hour12: false, timeZone: 'America/Halifax' },
        );
        console.log('Halifax hour: '+hourInHalifax);

        const start = new Date();
        if (hourInHalifax >= 23) {
            start.setDate(start.getDate() + 1);
        }
        const end = (new Date()).setDate(start.getDate() + 30);
        const workingDays = [];

        for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            if ([6, 0].includes(dt.getDay())) {
                continue;
            }

            if (-1 !== disabledDates.indexOf($.datepicker.formatDate('yy-mm-dd', dt))) {
                continue;
            }

            workingDays.push(new Date(dt));
        }

        if (hourInHalifax < 11) {
            workingDays.splice(0, 3);
        } else {
            workingDays.splice(0, 4);
        }

        if (0 === workingDays.length) {
            console.error('No working days found.');

            return null;
        }

        console.log('First working day:', workingDays[0]);

        return workingDays[0];
    };

    const disableDates = function (checkDate) {
        if (-1 !== disabledDates.indexOf($.datepicker.formatDate('yy-mm-dd', checkDate))) {
            return [false];
        }

        const dayOfWeek = checkDate.getDay();

        // Saturday or Sunday
        if (dayOfWeek === 6 || dayOfWeek === 0) {
            return [false];
        }

        return [true];
    };

    $('[rm-date-picker]').datepicker({
        beforeShowDay: disableDates,
        minDate: minDate(),
        maxDate: 31 * 6, // 6 months
    });

    $('input.ready_preference').change(function () {
        if (this.value !== 'delayed_until_date') {
            $('#shipping_date-wrap').addClass('hide');
            $('#shipping_date').val('').prop('required', false);
        } else {
            $('#shipping_date-wrap').removeClass('hide');
            $('#shipping_date').prop('required', true);
        }
    });

    // after page loads, the field may be selected so trigger a change so it shows the date if delayed
    setTimeout(() => {
        $('input.ready_preference:checked').trigger('change');
    }, 200);
});
